import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import {
  SETTINGS_ACCOUNT,
  SETTINGS_NOTIFICATIONS,
  SETTINGS_PAYMENTS,
  SETTINGS_SECURITY,
  SETTINGS_TEAM_SETTINGS,
  SETTINGS_VIRTUAL_OFFICE
} from '../../routes/routes';
import { CaptionText, H1, P1, P2, P3 } from '../../styles/FontStyles';
import { PageTitle } from '../../styles/GlobalComponents';
import { color, colors } from '../../styles/GlobalStyles';
import {
  Icon,
  IconSettingsAccount,
  IconSettingsNotifications,
  IconSettingsPassword,
  IconSettingsPayments,
  IconSettingsTeamSettings,
  IconSettingsVirtualOffice
} from '../../styles/Icons';
import { NavigationWrapper, NavItem } from './SettingsStyled';
import { useAppSelector } from '../../app/hooks';
import { UserTypes } from '../../types/loginTypes';
import { isPartnerHelper } from '../../helpers/helperFunctions';

export const SettingsNavigation = () => {
  const { t } = useTranslation('settings');
  const location = useLocation();
  const { userInfo } = useAppSelector((state) => state.auth);

  const isPartner = isPartnerHelper(
    userInfo?.user?.currentVirtualOfficeLicence?.dateEnd || ''
  );

  const [routes, setRoutes] = useState([
    {
      title: 'Account',
      subtitle: 'Edit your profile',
      icon: IconSettingsAccount,
      link: SETTINGS_ACCOUNT
    },
    {
      title: 'Security',
      subtitle: 'Protect your account',
      icon: IconSettingsPassword,
      link: SETTINGS_SECURITY
    },
    {
      title: 'Wallets',
      subtitle: 'Edit your wallets',
      icon: IconSettingsPayments,
      link: SETTINGS_PAYMENTS
    },
    {
      title: 'Back Office',
      subtitle: 'Manage your subscription',
      icon: IconSettingsVirtualOffice,
      link: SETTINGS_VIRTUAL_OFFICE,
      disabled: false,
      hidden: !isPartner
    },
    {
      title: t('navigation.notifications_t'),
      subtitle: t('navigation.notifications_s'),
      icon: IconSettingsNotifications,
      link: SETTINGS_NOTIFICATIONS,
      hidden: true
    },
    {
      title: 'Team Settings',
      subtitle: 'Change your team settings',
      icon: IconSettingsTeamSettings,
      link: SETTINGS_TEAM_SETTINGS,
      hidden: false
    }
  ]);

  const removeElements = () => {
    let userTypeRoutes = [...routes];

    if (userInfo.userType === UserTypes.Regular) {
      setRoutes(routes);
    } else {
      userTypeRoutes.splice(3, 1);

      userTypeRoutes.splice(4, 1);

      setRoutes(userTypeRoutes);
    }
  };

  useEffect(() => {
    removeElements();
  }, []);

  return (
    <NavigationWrapper>
      <PageTitle mt='0'>{t('navigation.title')}</PageTitle>
      {routes.map((route, i) => {
        if (route.hidden) return null;

        if (route.disabled)
          return (
            <NavItem disabled>
              <Icon
                mr='20'
                color={
                  location.pathname === route.link
                    ? color.colors.neutral0
                    : color.colors.neutral900
                }>
                <route.icon />
              </Icon>
              <div>
                <P1
                  bold
                  color={
                    location.pathname === route.link
                      ? color.colors.neutral0
                      : color.colors.neutral900
                  }>
                  {route.title}
                </P1>
                <P3
                  color={
                    location.pathname === route.link
                      ? color.colors.neutral0
                      : color.colors.neutral900
                  }>
                  {route.subtitle}
                </P3>
              </div>
            </NavItem>
          );

        return (
          <NavLink
            key={i}
            to={route.link}
            exact
            activeClassName='settingsNavActive'
            className='settingsNav'>
            <NavItem>
              <Icon
                mr='20'
                color={
                  location.pathname === route.link
                    ? color.colors.neutral0
                    : color.colors.neutral900
                }>
                <route.icon />
              </Icon>
              <div>
                <P1
                  bold
                  color={
                    location.pathname === route.link
                      ? color.colors.neutral0
                      : color.colors.neutral900
                  }>
                  {route.title}
                </P1>
                <P3
                  color={
                    location.pathname === route.link
                      ? color.colors.neutral0
                      : color.colors.neutral900
                  }>
                  {route.subtitle}
                </P3>
              </div>
            </NavItem>
          </NavLink>
        );
      })}
    </NavigationWrapper>
  );
};
